import axios from 'axios';

const apiClient = axios.create({
    baseURL: 'https://api2.queuing4oranges.com',
});

export default apiClient;